/// <reference path="../../../../Scripts/Compilator/global.d.ts" />

var Compilator = Compilator || {};

Compilator.Login = {
  texts: {
    errorTitle: '',
    errorMessage: '',
    okButton: '',
    logonTitle: '',
    changePasswordTitle: '',
    forgotPasswordTitle: '',
    logonCurrentUserActionUrl: ''
  },

  openChangePasswordWindow: function() {
    var kendoWindowOptions = {
      title: this.texts.changePasswordTitle, 
      width: 500,
      height: 400,
      windowName: 'kw_changePassword',
      onWindowClose: this.onChangePasswordWindowClose
    };
      
    $url.Login.ChangePassword.Index.kendoWindow($('#Username').val(), kendoWindowOptions);
  }, 
  onChangePasswordWindowClose: function (args) {
    try {
      document.location = document.location;
    }
    catch (e) {

    }
  },
  openLogonWindow: function () {
    var kendoWindowOptions = {
      title: this.texts.logonTitle,
      width: 400,
      height: 300,
      windowName: 'kw_login',
      iframe: false,
      onWindowClose: this.onLogonWindowClose
    };
    $url.Login.Logon.Index.kendoWindow(kendoWindowOptions);
  },
  onLogonWindowClose: function (args) {
    if (args) {
      if (args.status === compilator.windowHandler.kendo.dialogResultOk) {
        $.ajax({
          url: Compilator.Login.texts.logonCurrentUserActionUrl,
          type: 'GET',
          cache: false,
          data: {
            branchId: args.BranchId,
            departmentId: args.Department
          },
          success: function (response) {
            window.localStorage.setItem("compAuthKey", response.SecurityToken);
            document.location = response.UrlRedirect;
          },
          error: function (response) {
            console.log('Error when logging in: ');
            console.log(JSON.stringify(response));
            $kendo.openKendoWindowNotification(Compilator.Login.texts.errorTitle, Compilator.Login.texts.errorMessage, Compilator.Login.texts.okButton, false, false, function () {
              document.location = document.location;
            });
          }
        });
      }
      else {
        $url.Login.Login.CancelLogin.ajax({
          success: function (response) {
            document.location = response;
          },
          error: function (response) {
            console.log('Error when cancelling log in: ');
            console.log(JSON.stringify(response));
            document.location = document.location;
          }
        });
      }
    }
  },
  openForgotPasswordDialog: function () {
    $kendo.openNewKendoWindow("/Login/Login/ForgotPassword", {
      iframe: false,
      windowName: '_kwForgotPassword',
      title: this.texts.forgotPasswordTitle,
      width: 600
    });
  }
}

let $login = Compilator.Login;




